module.exports = __webpack_public_path__ + "static/PartnerStampRed-53f72b9487821a879122640047e51a60.png";